import { useTranslate } from '@tolgee/react';
import { Button, TableColumnsType, TableProps, Tag } from 'antd';
import ScrollTable from 'components/ScrollTable';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { StarRate } from 'views/Review/components/Profile';
import { ReactComponent as ThreeSvg } from './assets/haoping.svg';
import { ReactComponent as TwoSvg } from './assets/yiban.svg';
import { ReactComponent as OneSvg } from './assets/chaping.svg';
import Icon from '@ant-design/icons';
import dayjs from 'dayjs';

type RT = Dashboard.PlatformData.CsatData;

function CsatDetailTable({
  platform,
  onCheckConversation,
  ...otherProps
}: TableProps<RT> & {
  platform: General.PlatformUpperCase;
  onCheckConversation: (record: RT) => void;
}) {
  const { t } = useTranslate();

  const columns: TableColumnsType<RT> = [
    {
      key: 'region',
      dataIndex: 'region',
      title: t('站点'),
      width: 60,
    },
    {
      key: 'storeAlias',
      dataIndex: 'storeAlias',
      title: t('ViewShops.店铺别名'),
      width: 160,
      render: (alias: RT['storeAlias']) => alias || '-',
    },
    {
      key: 'storeName',
      dataIndex: 'storeName',
      title: t('店铺名称'),
      width: 160,
      render: (name: RT['storeName']) => name || '-',
    },
    {
      key: 'buyerNick',
      dataIndex: 'buyerNick',
      title: t('买家昵称'),
      width: 160,
    },
    {
      key: 'csatScore',
      dataIndex: 'csatScore',
      title: t('reviewSetting.评分'),
      width: 120,
      render: (score) => {
        if (isTiKTokUpperCase(platform)) {
          return <StarRate disabled value={score} />;
        }
        if (score === 2) {
          return (
            <Tag color="green">
              <Icon component={ThreeSvg} />
              {t('review.好评')}
            </Tag>
          );
        }
        if (score === 1) {
          return (
            <Tag color="warning">
              <Icon component={TwoSvg} />
              {t('一般')}
            </Tag>
          );
        }
        if (score === 0) {
          return (
            <Tag color="error">
              <Icon component={OneSvg} />
              {t('aide.差评')}
            </Tag>
          );
        }
        return '-';
      },
    },
    {
      key: 'scoreTimeStamp',
      dataIndex: 'scoreTimeStamp',
      title: t('评分时间'),
      width: 160,
      render: (time: RT['scoreTimeStamp']) => dayjs(Number(time)).format('YYYY/MM/DD HH:mm'),
    },
    {
      key: 'operate',
      title: t('操作'),
      width: 110,
      fixed: 'right',
      render: (_, record) => (
        <Button type="link" onClick={() => onCheckConversation(record)}>
          {t('查看会话')}
        </Button>
      ),
    },
  ];

  return <ScrollTable columns={columns} {...otherProps} />;
}

export default CsatDetailTable;
